import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactHero />
      <ContactInformation />
      <Footer />
    </div>;
}